import styled from '@emotion/styled';
import { Spacings, Fonts, mediaQuery } from '@styles/index';
import GoalCard from './GoalCard';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const GoalsContainer = styled.div`
  width: 1136px;
  padding-top: ${Spacings.SPACING_20B};
  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding: ${Spacings.SPACING_12B} ${Spacings.SPACING_4B} 0px
      ${Spacings.SPACING_4B};
  }
  ${mediaQuery.uptoTablet} {
    width: 100%;
    padding: ${Spacings.SPACING_12B} ${Spacings.SPACING_4B} 0px
      ${Spacings.SPACING_4B};
  }
`;

const GoalHeading = styled.p`
  color: var(--color-i-gray-13);
  font-size: ${Fonts.P1};
  font-weight: ${Fonts.SEMIBOLD};
`;

const GoalCardContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: auto auto auto;
  margin-top: ${Spacings.SPACING_4B};
  gap: ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    grid-template-columns: auto;
    gap: ${Spacings.SPACING_4B};
  }
`;

const AllCentreGoals = ({ goalData }) => {
  const data = goalData?.data;
  const title = goalData?.title;

  return (
    <Wrapper>
      <GoalsContainer>
        {title && <GoalHeading>{title}</GoalHeading>}
        <GoalCardContainer>
          {data?.map((currGoalData, index) => {
            return (
              <GoalCard
                goalCardData={currGoalData}
                key={`goal-card-${index}`}
              />
            );
          })}
        </GoalCardContainer>
      </GoalsContainer>
    </Wrapper>
  );
};

export default AllCentreGoals;
